import { useCallback } from "react"
import {
  ChevronRight,
  ListItem,
  ListItemLabel,
  useStyletron,
} from "@mezo-org/mezo-clay"

type ManageActionItemProps = {
  header: string
  description: string
  isDisabled?: boolean
  hasError?: boolean
  onClick: () => void
}

export default function ManageActionItem({
  header,
  description,
  isDisabled,
  hasError,
  onClick,
}: ManageActionItemProps) {
  const [, theme] = useStyletron()

  const manageActionItemHandler = useCallback(() => {
    if (isDisabled) return

    onClick()
  }, [isDisabled, onClick])

  return (
    <ListItem
      endEnhancer={() => (
        <ChevronRight
          color={
            isDisabled
              ? theme.colors.contentStateDisabled
              : theme.colors.contentTertiary
          }
        />
      )}
      onClick={manageActionItemHandler}
      overrides={{
        Root: {
          style: () => ({
            backgroundColor: theme.colors.backgroundSecondary,
            borderRadius: theme.borders.radius300,
          }),
        },
        Content: {
          style: () => ({
            border: "none",
            paddingTop: theme.sizing.scale100,
            paddingBottom: theme.sizing.scale100,
          }),
        },
        EndEnhancerContainer: {
          style: () => ({
            paddingRight: theme.sizing.scale100,
          }),
        },
      }}
    >
      <ListItemLabel
        description={description}
        overrides={{
          LabelContent: {
            style: () => ({ marginBottom: theme.sizing.scale100 }),
          },
          LabelDescription: {
            style: () => ({
              color: hasError
                ? theme.colors.negative
                : theme.colors.contentSecondary,
            }),
          },
        }}
      >
        {header}
      </ListItemLabel>
    </ListItem>
  )
}
